import apiService from '@/api/apiService';

export const exportVersion = async (id) => {
    const url = `/api/admin/balance/version/export/${id}`;

    return apiService.GET(url, {}, { ResponseType: 'blob' });
};
